import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const { protocol, host, port } = window.location;

export const userOrgApi = createApi({
    reducerPath: 'userOrgReducer',
    baseQuery: fetchBaseQuery({
        baseUrl: `${protocol}//${host}${port.length > 0 ? '' : `:${port}`}/api/userorg`,
    }),
    endpoints: () => ({}),
});
